import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectionButtonSizeEnum } from '../enums/selection-button-size.enum';
import { Tile } from '../models/tile.model';

@Component({
  selector: 'symphony-solo-tile-list',
  templateUrl: './tile-list.component.html',
  styleUrls: ['./tile-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileListComponent {
  @Input() public itemsList: Array<Tile>;
  @Input() public icon: string;
  @Output() public clickEvent: EventEmitter<number>;

  constructor() {
    this.clickEvent = new EventEmitter();
  }

  public onClick(item: Tile): void {
    this.clickEvent.emit(item.id);
  }

  public getIcon(item: Tile): string {
    if (item.icon) {
      return item.icon;
    }
    return this.icon;
  }

  public tileSize(): SelectionButtonSizeEnum {
    if (this.itemsList.length > 2) {
      return SelectionButtonSizeEnum.Small;
    } else {
      return SelectionButtonSizeEnum.Big;
    }
  }
}
